import React from 'react';

/** Small "by Name • Role • Time" line under entries */
export function EntryMeta({ entry, isDark }) {
  const fmtTime = (iso) => {
    if (!iso) return '';
    try {
      const d = new Date(iso);
      if (isNaN(d)) return '';
      return d.toLocaleString('en-IN', {
        timeZone: 'Asia/Kolkata', hour: '2-digit', minute: '2-digit',
        hour12: true, day: '2-digit', month: 'short',
      });
    } catch { return ''; }
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: '0.375rem',
      marginTop: '0.2rem',
      fontSize: '0.5rem', color: isDark ? '#4b5563' : '#d1d5db',
    }}>
      <span>{entry.added_by_name}</span>
      <span>•</span>
      <span>{entry.added_by_role}</span>
      <span>•</span>
      <span>{fmtTime(entry.created_at)}</span>
    </div>
  );
}
